import Client from './client';

export default class BillingStatementBatches extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  getFilesByIdAndBillingStatementBatchFileKey(id, billingStatementBatchFileKey, options = {}) {
    return this.makeRequest(`${this.host}/internal/billing/statement/batches/${id}/files/${billingStatementBatchFileKey}`, options);
  }

}
